/**
 * Fungi Farm SMS order updates opt-in (cart page + ajax cart modal).
 * Saves the cart attribute as soon as the box changes, so the value is kept
 * even with express checkout buttons or the modal checkout button.
 */
(function () {
  var ATTR = 'SMS order updates';
  var SEL = 'input[data-ff-sms-optin]';

  function setAll(checked) {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) nodes[i].checked = checked;
  }

  function save(checked) {
    var attrs = {};
    attrs[ATTR] = checked ? 'Yes' : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function sync() {
    if (!document.querySelector(SEL)) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        setAll(a[ATTR] === 'Yes');
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(SEL)) return;
    setAll(el.checked);
    save(el.checked);
  });

  function observeAjaxCart() {
    if (!window.MutationObserver) return;
    var target = document.getElementById('ajaxifyCart');
    if (!target) return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(sync, 60);
    }).observe(target, { childList: true });
  }

  function init() { observeAjaxCart(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
